// axiosInstance.js
import axios from 'axios';
import { toast } from 'react-toastify';
import { navigateToLogin } from './navigateToLogin';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: add token if exists
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor: handle 401 & errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error?.response?.data?.message === 'token_not_valid') {
      navigateToLogin();
    } else {
      console.error(error.response?.data?.message);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
